import { Grid, Box, Flex, Heading, Text, Button } from '@chakra-ui/react'
import { FC, Fragment, useMemo, useEffect } from 'react'

import useMrpOportunity from '@hook/mrp/use-oportunity'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'

import { parseOportunityMrpData } from '@helper/grid'
import { validateAppVersion } from '@helper/util/storangeClear'
import generic from '@service/generic'

const MrpOportunity: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()

  const {
    loading,
    headers,
    actions,
    filename,
    fetching,
    setFilename,
    setQuery,
    data,
    query,
    getDiscount,
    params,
    filters,
    setFilters,
    getData,
    filtersList,
    defaoutDesiredPeriod,
    handleUpdateParams,
    clearAllFilters
  } = useMrpOportunity()

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 272px)'
          : 'calc(100vh - 241px)'
        : hasSessions
        ? 'calc(100vh - 413px)'
        : 'calc(100vh - 382px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    generic
      .getMaintence('manutencao')
      .then(({ data: { data } }) => {
        validateAppVersion(data.version)

        if (data.valor === 'true') {
          window.location.href = '/manutencao'
        } else {
          // handleLocalParams()
          getFilters({
            companies: true,
            centers: true,
            providersForPurchase: true,
            simulationTypes: true,
            productManagers: true
          })
        }
      })
      .catch(() => {})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="MRP Oportunidade">
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={loading}
            onFilter={getData}
            submitLabel="Simular"
            changedValueDesiredPeriod={defaoutDesiredPeriod}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            query={query}
            onSearchChange={setQuery}
            onTitleChange={setFilename}
            toggleFilters={setFilters.toggle}
            isDisabled={loading || fetching || data.length === 0}
          />
          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os registros no banco de dados"
            />
          ) : !data.resumos ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <>
              <Grid gap="24px" templateColumns="2fr 1fr">
                <Grid
                  bg="gray.100"
                  templateColumns="2fr 1fr 1fr"
                  p={2}
                  borderRadius="8px"
                >
                  <Box p={2} borderBottom="solid 1px" borderColor="gray.200">
                    <Heading size="sm" textAlign="left" maxW="100%" isTruncated>
                      Sumário
                    </Heading>
                  </Box>
                  <Box p={2} borderBottom="solid 1px" borderColor="gray.200">
                    <Heading
                      size="sm"
                      textAlign="center"
                      maxW="100%"
                      isTruncated
                    >
                      MRP
                    </Heading>
                  </Box>
                  <Box p={2} borderBottom="solid 1px" borderColor="gray.200">
                    <Heading
                      size="sm"
                      textAlign="center"
                      maxW="100%"
                      isTruncated
                    >
                      Necessidade
                    </Heading>
                  </Box>

                  {data.sumarios.map((sumario: any, index: number) => (
                    <Fragment key={`sum-${index}`}>
                      <Box p={2}>
                        <Text>{sumario.tipo}</Text>
                      </Box>
                      <Box p={2}>
                        <Text textAlign="center">
                          R$
                          {sumario.mrp.toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </Text>
                      </Box>
                      <Box p={2}>
                        <Text textAlign="center">
                          {sumario.necessidade.toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </Text>
                      </Box>
                    </Fragment>
                  ))}
                </Grid>
                <Flex
                  flexDir="column"
                  alignItems="center"
                  justifyContent="space-between"
                  bg="gray.100"
                  borderRadius="8px"
                  p={4}
                >
                  <Heading textAlign="center" size="sm">
                    Desconto
                  </Heading>
                  <Heading size="md" fontWeight="400">
                    {data.percentualDesconto}%
                  </Heading>
                  <Button onClick={getDiscount} colorScheme="yellow" size="sm">
                    Calcular desconto
                  </Button>
                </Flex>
              </Grid>

              <GridQuantity data={data} disabled={data.length === 0} />

              <TableGrid
                id="oportunity-table"
                headers={headers}
                query={query}
                data={parseOportunityMrpData(data)}
                loading={fetching}
                isActions={false}
                height={tableHeight}
                itsSortable={true}
                entity="mrp-oportunity"
              />
            </>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default MrpOportunity
